import React from "react";
import LocalizedStrings from 'react-localization';
import { hashHistory } from 'react-router';
import { connect } from "react-redux";
import ClaimHeader from './Components/ClaimHeader/ClaimHeader'
import ClaimDetails from './Components/ClaimDetails/ClaimDetails'
import ClaimDocuments from './Components/ClaimDocuments/ClaimDocuments'
import ClaimActionButtons from './Components/ClaimActionButtons'
import * as actions from "./Redux/actions"
import BoxInc from "../../../shared-ui/BoxInc/Index";
import ButtonInc from '../../../shared-ui/ButtonInc';
import AddClaimNotes from "./Components/ClaimDetails/AddClaimNotes";
import AddClaimDocuments from "./Components/ClaimDocuments/AddClaimDocuments";
import DeleteClaimDocument from "./Components/ClaimDocuments/DeleteClaimDocument";
import AddClaimFacilityNotes from "./Components/ClaimDetails/AddClaimFacilityNotes";
import { hasAuthourity } from "../../../lib/access.es6";
import { ClaimTypeEnum, ClaimStatusEnum } from "../lib/enum";
import DownloadDocument from "../../../components/DownloadDocument/DownloadDocument";
import { localisedText } from "../../../lib/localisation.es6";
import * as documentActions from '../../../containers/DocumentGeneration/actions.es6';

import ClaimExpenses from './Components/ClaimExpenses/ClaimExpenses'
import AddClaimExpense from "./Components/ClaimExpenses/AddClaimExpense";
import DeleteClaimExpense from "./Components/ClaimExpenses/DeleteClaimExpense";
import find from 'lodash/find';
import AssignLawyerClaim from "./Components/ClaimDetails/AssignLawyerClaim";


class ClaimsProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: new LocalizedStrings(localisedText),
      openClaimNotesDialog: false,
      openAssignLawyerDialog: false,
      openClaimFacilityNotesDialog: false,
      openClaimDocumentsDialog: false,
      openClaimExpenseDialog: false,
      openEditClaimExpenseDialog: false,
      description: "",
      expanded: false,
      missingDocs: false,
      claimToDownload: null,
      policyToDownload: null,
      scrollPos: 0,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }


  componentWillMount() {
    let claim_guid = this.props.params.claim_guid
    this.props.dispatch(actions.getClaimProcessingDcpRequest({
      guid: claim_guid,
    }));

  }

  componentDidMount() {
    const savedScrollPos = sessionStorage.getItem('scrollPos');
    if (savedScrollPos) {
      try {
        window.scrollTo(0, parseInt(savedScrollPos));
      } catch (error) {
        console.error("Error scrolling:", error);
      }
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.setState({ scrollPos: window.pageYOffset });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.scrollPos !== this.state.scrollPos) {
      sessionStorage.setItem('scrollPos', this.state.scrollPos);
    }
      if (
            prevState.openClaimDocumentsDialog === true &&
            this.state.openClaimDocumentsDialog === false
          ) {
            let claim_guid = this.props.params.claim_guid;
            this.props.dispatch(
              actions.getClaimProcessingDcpRequest({
                guid: claim_guid,
              })
            );
          }
  }


  toggleClaimNotesDialog() {
    this.setState({ openClaimNotesDialog: !this.state.openClaimNotesDialog })
  }

  toggleAssignLawyerDialog() {
    this.setState({ openAssignLawyerDialog: !this.state.openAssignLawyerDialog })
  }

  toggleClaimFacilityNotesDialog() { 
    this.setState({ openClaimFacilityNotesDialog: !this.state.openClaimFacilityNotesDialog })
  }

  toggleClaimDocumentsDialog() {
    this.setState({ openClaimDocumentsDialog: !this.state.openClaimDocumentsDialog })
  }

  toggleClaimExpenseDialog() {
    this.setState({ openClaimExpenseDialog: !this.state.openClaimExpenseDialog, expanded: true })

  }

  toggleEditClaimExpenseDialog() {
    this.setState({ openEditClaimExpenseDialog: !this.state.openEditClaimExpenseDialog })
  }

  handleClaimExpense(payload) {
    this.props.dispatch(actions.createExpenseRequest(payload))
  }

  setClaimExpenseToDelete(expense) {
    this.props.dispatch(actions.setExpenseToDelete(expense));
  }
  deleteClaimExpense(expense) {
    this.props.dispatch(actions.deleteExpenseRequest({
      claim_guid: this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid,
      expense_guid: expense.guid
    }));
  }
  resetExpenseToDelete(expense) {
    this.props.dispatch(actions.resetExpenseToDelete(expense))
  }

  setClaimExpenseToEdit(expense) {
    console.log("set claim to edit", expense)
    this.props.dispatch(actions.setExpenseToEdit(expense));
  }

  editClaimExpense(payload) {
    this.props.dispatch(actions.expenseEditRequest(
      payload
    ));
  }
  resetExpenseToEdit(expense) {
    this.props.dispatch(actions.resetExpenseEdit(expense))
  }
  handleClaimNotes(payload) {
    console.log("claim notes payload", payload)
    this.props.dispatch(actions.createClaimNote(
      payload));
  }

   handleCreateClaimNotes = (payload) => {
    this.props.dispatch(actions.createClaimNote(
      payload));
  }
  updateClaimNotes = (payload) => {
    this.props.dispatch(actions.updateClaimNote(
      payload));
  }

  deleteCLaimNotes = (payload) => {
    this.props.dispatch(actions.deleteClaimNote(payload));
  }

  handleClaimFacilityNotes(payload) {
    this.props.dispatch(actions.claimFacilityNotesRequest(
      payload));
  }

  deleteClaimDocument(document) {
    this.props.dispatch(actions.deleteclaimDocumentsRequest({
      claim_guid: this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid,
      claim_doc_guid: document.guid
    }));
  }
  setClaimDocumentToDelete(document) {
    this.props.dispatch(actions.setDocumentsToDelete(document));
  }

  resetDocumentToDelete(document) {
    this.props.dispatch(actions.resetDocumentToDelete(document))
  }


  viewPolicyDetail(policyNumber) {
    if (policyNumber) {
      hashHistory.push(`admin/policy-processing/${policyNumber}`)
    } else {
      return
    }
  }

  isLegalClaim(claim) {
    const hasLegalCoverBenefit = !!find(claim.benefits, { type: "Legal Cover" })
    return hasLegalCoverBenefit
  }

  isMedicalCashClaim(claim) {
    const hasMedicalCashPlanBenefit = !!find(claim.benefits, { type: "Medical Cash Plan" })
    return hasMedicalCashPlanBenefit
  }

  isAccidentalDeathClaim(claim) {
    const hasAccidentalDeathBenefit = !!find(claim.benefits, { type: "Accidental death and disability cover P 50,000" }) || !!find(claim.benefits, { type: "Accidental death and disability cover P 20,000" })
    return hasAccidentalDeathBenefit
  }
  assignLawyer(payload) {
    this.props.dispatch(actions.assignLawyerRequest(payload));
  }

  markInvoiceAsPaid(payload) {
    this.props.dispatch(actions.markInvoiceAsPaidRequest(payload));
  }

  isRoadsideAssistanceClaim(claim) {
    const hasRoadsideAssistanceBenefit = !!find(claim.benefits, { type: "Roadside Assistance" })
    return hasRoadsideAssistanceBenefit
  }

  isBDFandPrisonsClaim(claim) {
    const hasBDFandPrisonsBenefit = !!find(claim.benefits, { type: "Police, Prisons, and BDF disciplinary Boards" })
    return hasBDFandPrisonsBenefit
  }

  handleResetClaimNotesError(){
    this.props.dispatch(actions.resetUpdateClaimNoteError())
  }
  handleResetClaimNotesSuccess(){
    this.props.dispatch(actions.resetUpdateClaimNoteSuccess())
  }

  getClaimType(claim) {
    if (!claim) return ""
    if (this.isLegalClaim(claim)) return ClaimTypeEnum.legal
    if (this.isMedicalCashClaim(claim)) return ClaimTypeEnum.medicalCashPlan
    if (this.isAccidentalDeathClaim(claim)) return ClaimTypeEnum.accidentalDeath
    if (this.isRoadsideAssistanceClaim(claim)) return ClaimTypeEnum.roadSideAssistance
    if (this.isBDFandPrisonsClaim(claim)) return ClaimTypeEnum.bdfAndPrisons
    return ""
  }
  render() {
    const type = this.getClaimType(this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp);
    const benefits = this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp ? this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.benefits : []
    const legalBenefits = find(benefits, { type: "Legal Cover" })
    const medicalCashBenefits = find(benefits, { type: "Medical Cash Plan" })
    console.log("claim processing props", this.props.ClaimProcessingCoverLinkData)

    if (!hasAuthourity('VIEW_CLAIM')) {
      return <p>You are unauthorized to view claim.</p>
    }

    if (this.props.ClaimProcessingCoverLinkData.get_claimsProcessingDcp_loader) {
      return <>
        <p>loading....</p>
      </>
    }
    if (!this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp) {
      return <>
        <p>nothing found </p>
      </>
    }
    const templateDocuments = this.props.documentGenerationData.templateDocuments;
    return (
      <>
        <ClaimHeader
          claimData={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp}

        />
        <BoxInc
          title="Claims Details"
          expanded
          style={{ marginTop: "40px" }}
          actionButtons={[<ButtonInc
            variant="contained"
            color="primary"
            size="large"
            onClick={() => this.setState({
              claimToDownload: this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp
            })}
          >
            Download Claim Document

          </ButtonInc>,
          <ButtonInc
            variant="contained"
            color="primary"
            size="large"
            onClick={() => this.viewPolicyDetail(this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.claim_details.policy_number)}
          >
            View Policy

          </ButtonInc>

          ]

          }
        >

          <ClaimDetails
            claim={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp}
            toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
            openClaimNotesDialog={this.state.openClaimNotesDialog}
            isLegalClaim={this.isLegalClaim.bind(this)}
            isMedicalCashClaim={this.isMedicalCashClaim.bind(this)}
            legalBenefits={legalBenefits}
            medicalCashBenefits={medicalCashBenefits}
            isAccidentalDeathClaim={this.isAccidentalDeathClaim.bind(this)}
            isRoadsideAssistanceClaim={this.isRoadsideAssistanceClaim.bind(this)}
            toggleAssignLawyerDialog={this.toggleAssignLawyerDialog.bind(this)}
            isBDFandPrisonsClaim={this.isBDFandPrisonsClaim.bind(this)}

            updateClaimNotes={this.updateClaimNotes}
            deleteClaimNotes={this.deleteCLaimNotes}

            showUpdateNoteProgressAlert={this.props.ClaimProcessingCoverLinkData.updateClaimNoteLoader}
            showUpdateNotesSuccessAlert={this.props.ClaimProcessingCoverLinkData.updateClaimNoteSuccess}
            showUpdateNotesErrorAlert={!!this.props.ClaimProcessingCoverLinkData.updateClaimNoteError}
            updateClaimNoteError={this.props.ClaimProcessingCoverLinkData.updateClaimNoteError}


            showDeleteNoteProgressAlert={this.props.ClaimProcessingCoverLinkData.deleteClaimNoteLoader}
            showDeleteNotesSuccessAlert={this.props.ClaimProcessingCoverLinkData.deleteClaimNoteSuccess}
            showDeleteNotesErrorAlert={!!this.props.ClaimProcessingCoverLinkData.deleteClaimNoteError}
            deleteNotesError={this.props.ClaimProcessingCoverLinkData.deleteClaimNoteError}

            resetNotesSuccessAlert={this.handleResetClaimNotesSuccess.bind(this)}
            resetNotesErrorAlert={this.handleResetClaimNotesError.bind(this)}

          />
          <AddClaimFacilityNotes
            toggleClaimFacilityNotesDialog={this.toggleClaimFacilityNotesDialog.bind(this)}
            openClaimFacilityNotesDialog={this.state.openClaimFacilityNotesDialog}

            handleClaimFacilityNotes={this.handleClaimFacilityNotes.bind(this)}
            claimguid={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid}

            showCreateFacilityNoteProgressAlert={this.props.ClaimProcessingCoverLinkData.ClaimFacilityNotesLoader}
            showCreateFacilityNotesSuccessAlert={this.props.ClaimProcessingCoverLinkData.ClaimFacilityNotesSuccess}
            showCreateFacilityNotesErrorAlert={!!this.props.ClaimProcessingCoverLinkData.ClaimFacilityNotesError}
            CreateFacilityNotesError={this.props.ClaimProcessingCoverLinkData.ClaimFacilityNotesError}
            resetCreateFacilityNotesSuccessAlert={() => { this.props.dispatch(actions.resetFacilityClaimNotesSuccess()) }}
            resetCreateFacilityNotesErrorAlert={() => { this.props.dispatch(actions.resetCreateExpenseError()) }}
          />
          <AddClaimNotes

            toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
            openClaimNotesDialog={this.state.openClaimNotesDialog}

            handleClaimNotes={this.handleClaimNotes.bind(this)}
            claimguid={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid}

            showCreateNoteProgressAlert={this.props.ClaimProcessingCoverLinkData.ClaimNotesLoader}
            showCreateNotesSuccessAlert={this.props.ClaimProcessingCoverLinkData.ClaimNotesSuccess}
            showCreateNotesErrorAlert={!!this.props.ClaimProcessingCoverLinkData.ClaimNotesError}
            CreateNotesError={this.props.ClaimProcessingCoverLinkData.ClaimNotesError}
            resetCreateNotesSuccessAlert={() => { this.props.dispatch(actions.resetCreateClaimNoteSuccess()) }}
            resetCreateNotesErrorAlert={() => { this.props.dispatch(actions.resetCreateClaimNoteError()) }}
          />


          {
            (type === ClaimTypeEnum.legal || type === ClaimTypeEnum.bdfAndPrisons) &&
            this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.status === ClaimStatusEnum.Approved &&
            <AssignLawyerClaim
              openAssignLawyerDialog={this.state.openAssignLawyerDialog}
              toggleAssignLawyerDialog={this.toggleAssignLawyerDialog.bind(this)}
              assignLawyer={this.assignLawyer.bind(this)}
              claimguid={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid}

              showAddLawyerProgressAlert={this.props.ClaimProcessingCoverLinkData.assignLawyerLoader}
              showAddLawyerSuccessAlert={this.props.ClaimProcessingCoverLinkData.assignLawyerSuccess}
              showAddLawyerErrorAlert={!!this.props.ClaimProcessingCoverLinkData.assignLawyerError}
              addLawyerError={this.props.ClaimProcessingCoverLinkData.assignLawyerError}
              resetAddLawyerSuccessAlert={() => { this.props.dispatch(actions.resetAddLawyerSuccessAlert()) }}
              resetAddLawyerErrorAlert={() => { this.props.dispatch(actions.resetAddLawyerError()) }}

            />
          }

        </BoxInc>
        <BoxInc
          title="Claims Documents "
          expanded={true}
          style={{ marginTop: "30px" }}
          actionButtons={[<ButtonInc
            variant="contained"
            color="primary"
            size="large"
            onClick={() => this.setState({
              policyToDownload: {
                guid: this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.policy_guid
              }
            })}
          >
            Download Policy Document

          </ButtonInc>]}
        >
          <AddClaimDocuments
            description={this.state.description}
            toggleClaimDocumentsDialog={this.toggleClaimDocumentsDialog.bind(this)}
            openClaimDocumentsDialog={this.state.openClaimDocumentsDialog}
            claim_guid={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid}
            saveClaimDocument={(doc) => this.props.dispatch(actions.saveClaimDcpDocumentRequest(doc))}
            error={this.props.ClaimProcessingCoverLinkData.saveClaimDcpDocumentError}
            claimExpense={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.benefit_usages}
            type={type}

          />
          <ClaimDocuments
            setDescription={(description) => this.setState({ description })}
            claimDocuments={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.claim_documents}
            setClaimDocumentToDelete={this.setClaimDocumentToDelete.bind(this)}
            toggleMissingDocs={() => this.setState({ missingDocs: true })}
            missingDocs={this.state.missingDocs}
            openUploadDialog={this.toggleClaimDocumentsDialog.bind(this)}
            type={type}
          />
          <DeleteClaimDocument
            DocumentToDelete={this.props.ClaimProcessingCoverLinkData.documentsToDelete}
            deleteClaimDocument={this.deleteClaimDocument.bind(this)}


            resetDocumentToDelete={this.resetDocumentToDelete.bind(this)}
            showDeleteDocumentProgressAlert={this.props.ClaimProcessingCoverLinkData.hardDeleteExpenseLoader}
            showDeleteDocumentSuccessAlert={this.props.ClaimProcessingCoverLinkData.hardDeleteDocumentSuccess}
            showDeleteDocumentErrorAlert={!!this.props.ClaimProcessingCoverLinkData.deleteClaimDocumentError}
            deleteDocumentError={this.props.ClaimProcessingCoverLinkData.deleteClaimDocumentError}

            resetDeleteDocumentSuccessAlert={() => {
              this.props.dispatch(actions.resetHardDeleteDocumentSuccess())
            }}
            resetDeleteDocumentErrorAlert={() => { this.props.dispatch(actions.resetHardDeleteDocumentError()) }}

          />
        </BoxInc>

        <BoxInc
          title="Claim Notes"
          expanded={true}
          style={{ marginTop: "30px" }}
          actionButtons={[<ButtonInc
            variant="contained"
            color="primary"
            size="large"
            onClick={this.toggleClaimNotesDialog.bind(this)}
          >
            Add Note
          </ButtonInc>]}
        >
          {/* <ClaimNotes
            claimNotes={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.claim_notes}
            claimGuid={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.guid}
            updateClaimNotes={this.updateClaimNotes}
            deleteClaimNotes={this.deleteCLaimNotes}
            
            showUpdateNoteProgressAlert={this.props.ClaimProcessingCoverLinkData.ClaimNotesLoader}
            showUpdateNotesSuccessAlert={this.props.ClaimProcessingCoverLinkData.ClaimNotesSuccess}
            showUpdateNotesErrorAlert={!!this.props.ClaimProcessingCoverLinkData.ClaimNotesError}
            
            
            showDeleteNoteProgressAlert={this.props.ClaimProcessingCoverLinkData.ClaimNotesLoader}
            showDeleteNotesSuccessAlert={this.props.ClaimProcessingCoverLinkData.ClaimNotesSuccess}
            showDeleteNotesErrorAlert={!!this.props.ClaimProcessingCoverLinkData.ClaimNotesError}
            DeleteNotesError={this.props.ClaimProcessingCoverLinkData.ClaimNotesError}

            resetNotesSuccessAlert={this.handleResetClaimNotesSuccess.bind(this)}
            resetNotesErrorAlert={this.handleResetClaimNotesError.bind(this)}
          /> */}
        </BoxInc>

        <BoxInc
          title={type === ClaimTypeEnum.legal ? "Claim Invoices " : " Claim Invoices "}
          expanded={this.state.expanded}
          style={{ marginTop: "30px" }}
          actionButtons={[<ButtonInc
            variant="contained"
            color="primary"
            size="large"
            onClick={this.toggleClaimExpenseDialog.bind(this)}
            hasPermision={hasAuthourity('UPDATE_CLAIM')}
          >
            {
              type === ClaimTypeEnum.legal ? "Add invoice details" : " Add  invoice details"
            }

          </ButtonInc>]}
        >
          <ClaimExpenses
            claimExpense={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp}
            setClaimExpenseToDelete={this.setClaimExpenseToDelete.bind(this)}
            setClaimExpenseToEdit={this.setClaimExpenseToEdit.bind(this)}
            isLegalClaim={this.isLegalClaim.bind(this)}
            isMedicalCashClaim={this.isMedicalCashClaim.bind(this)}
            isAccidentalDeathClaim={this.isAccidentalDeathClaim.bind(this)}
            isRoadsideAssistanceClaim={this.isRoadsideAssistanceClaim.bind(this)}
            toggleEditClaimExpenseDialog={this.toggleEditClaimExpenseDialog.bind(this)}
            openEditClaimExpenseDialog={this.state.openEditClaimExpenseDialog}
            type={type}
            markInvoiceAsPaid={this.markInvoiceAsPaid.bind(this)}
            showMarkInvoiceAsPaidProgressAlert={
              this.props.ClaimProcessingCoverLinkData.markInvoiceAsPaidLoader
            }
            showMarkInvoiceAsPaidSuccessAlert={
              this.props.ClaimProcessingCoverLinkData.markInvoiceAsPaidSuccess
            }
            showMarkInvoiceAsPaidErrorAlert={
              !!this.props.ClaimProcessingCoverLinkData.markInvoiceAsPaidError
            }
            markInvoiceAsPaidError={
              this.props.ClaimProcessingCoverLinkData.markInvoiceAsPaidError
            }
            resetMarkInvoiceAsPaidSuccessAlert={() => {
              this.props.dispatch(actions.resetMarkInvoiceAsPaidSuccess())
            }}
            resetMarkInvoiceAsPaidErrorAlert={() => {
              this.props.dispatch(actions.resetMarkInvoiceAsPaidError())
            }}
          />

          <AddClaimExpense
            toggleClaimExpenseDialog={this.toggleClaimExpenseDialog.bind(this)}
            openClaimExpenseDialog={this.state.openClaimExpenseDialog}
            claim={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp}
            handleClaimExpense={this.handleClaimExpense.bind(this)}

            showCreateExpenseProgressAlert={this.props.ClaimProcessingCoverLinkData.createdClaimExpenseLoader}
            showCreateExpenseSuccessAlert={this.props.ClaimProcessingCoverLinkData.createdClaimExpenseSuccess}
            showCreateExpenseErrorAlert={!!this.props.ClaimProcessingCoverLinkData.createdClaimExpenseError}
            CreateExpenseError={this.props.ClaimProcessingCoverLinkData.createdClaimExpenseError}
            resetCreateExpenseSuccessAlert={() => { this.props.dispatch(actions.resetCreateExpenseSuccess()) }}
            resetCreateExpenseErrorAlert={() => { this.props.dispatch(actions.resetCreateExpenseError()) }}
            type={type}
          />
          <DeleteClaimExpense
            expenseToDelete={this.props.ClaimProcessingCoverLinkData.expenseToDelete}
            deleteClaimExpense={this.deleteClaimExpense.bind(this)}

            resetExpenseToDelete={this.resetExpenseToDelete.bind(this)}
            showDeleteExpenseProgressAlert={this.props.ClaimProcessingCoverLinkData.hardDeleteExpenseLoader}
            showDeleteExpenseSuccessAlert={this.props.ClaimProcessingCoverLinkData.hardDeleteExpenseSuccess}
            showDeleteExpenseErrorAlert={!!this.props.ClaimProcessingCoverLinkData.deleteExpenseErrors}
            deleteExpenseError={this.props.ClaimProcessingCoverLinkData.deleteExpenseErrors}

            resetDeleteExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetHardDeleteExpenseSuccess())
            }}
            resetDeleteExpenseErrorAlert={() => { this.props.dispatch(actions.resetHardDeleteExpenseError()) }}
          />

        </BoxInc>



        <ClaimActionButtons
          claim={this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp}
          submitClaimAction={(claimActionPayload) => this.props.dispatch(actions.claimActionRequest(claimActionPayload))}
          loading={this.props.ClaimProcessingCoverLinkData.ClaimActionLoader}
          error={this.props.ClaimProcessingCoverLinkData.ClaimActionError}
          missingDocs={this.state.missingDocs}
        />


        <DownloadDocument
          labels={this.state.labels}
          identifier="Claims"
          entityDocument={
            this.props.documentGenerationData.entityDocument
          }
          entity={this.state.claimToDownload}
          resetEntity={() => this.setState({ claimToDownload: null })}
          templates={templateDocuments}
          getTemplates={() => this.props.dispatch(documentActions.getTemplateDocumentsRequest('Claim'))}
          getTemplatesLoader={this.props.documentGenerationData.getTemplateDocumentloader}
          isEmptyTemplatesResponse={this.props.documentGenerationData.isEmptyTemplates}
          downloadDocument={guid => {
            this.props.dispatch(
              documentActions.downloadDocumentRequest({
                entity_guid: this.state.claimToDownload.guid,
                template_guid: guid,
              })
            );
          }}
          resetGetTemplateDocuments={() => {
            this.props.dispatch(documentActions.resetGetTemplateDocuments());
          }}
          resetDownloadDocument={() => {
            this.props.dispatch(documentActions.resetDocumentEntity());
          }}
          showDownloadDocumentProgressAlert={
            this.props.documentGenerationData.downloadDocumentLoader
          }
          showDownloadDocumentSuccessAlert={
            this.props.documentGenerationData.downloadDocumentSuccess
          }
          showDownloadDocumentErrorAlert={
            !!this.props.documentGenerationData.downloadDocumentError
          }
          downloadDocumentError={
            this.props.documentGenerationData.downloadDocumentError
          }
          resetDownloadDocumentSuccessAlert={() => {
            this.props.dispatch(
              documentActions.resetDownloadDocumentSuccess()
            );
          }}
          resetDownloadDocumentErrorAlert={() => {
            this.props.dispatch(
              documentActions.resetDownloadDocumentError()
            );
          }}

          goToTemplatesPage={() => {
            hashHistory.push('admin/view_doc_templates');
          }}
        />
        <DownloadDocument
          labels={this.state.labels}
          identifier="Policies"
          entityDocument={
            this.props.documentGenerationData.entityDocument
          }
          entity={this.state.policyToDownload}
          resetEntity={() => this.setState({ policyToDownload: null })}
          templates={templateDocuments}
          getTemplates={() => this.props.dispatch(documentActions.getTemplateDocumentsRequest('Policy'))}
          getTemplatesLoader={this.props.documentGenerationData.getTemplateDocumentloader}
          isEmptyTemplatesResponse={this.props.documentGenerationData.isEmptyTemplates}
          downloadDocument={guid => {
            this.props.dispatch(
              documentActions.downloadDocumentRequest({
                entity_guid: this.props.ClaimProcessingCoverLinkData.claimsProcessingDcp.policy_guid,
                template_guid: guid,
              })
            );
          }}
          resetGetTemplateDocuments={() => {
            this.props.dispatch(documentActions.resetGetTemplateDocuments());
          }}
          resetDownloadDocument={() => {
            this.props.dispatch(documentActions.resetDocumentEntity());
          }}
          showDownloadDocumentProgressAlert={
            this.props.documentGenerationData.downloadDocumentLoader
          }
          showDownloadDocumentSuccessAlert={
            this.props.documentGenerationData.downloadDocumentSuccess
          }
          showDownloadDocumentErrorAlert={
            !!this.props.documentGenerationData.downloadDocumentError
          }
          downloadDocumentError={
            this.props.documentGenerationData.downloadDocumentError
          }
          resetDownloadDocumentSuccessAlert={() => {
            this.props.dispatch(
              documentActions.resetDownloadDocumentSuccess()
            );
          }}
          resetDownloadDocumentErrorAlert={() => {
            this.props.dispatch(
              documentActions.resetDownloadDocumentError()
            );
          }}

          goToTemplatesPage={() => {
            hashHistory.push('admin/view_doc_templates');
          }}
        />
      </>
    )
  }

}
export default connect((state) => ({
  documentGenerationData: state.documentGeneration,
  customerData: state.currentCustomer,
  ClaimProcessingCoverLinkData: state.ClaimProcessingCoverLinkData,
  PolicyProcessingData: state.PolicyProcessingData,
  claimDashboardData: state.claimDashboardData,
  globalData: state.global,
}))(ClaimsProcessing);